import SortingCriteria from "../../../../Lib/Fs.Core.Data/SortingCriteria";
import PagingCriteria from "../../../../Lib/Fs.Core.Data/PagingCriteria";
import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework'
import { PLATFORM } from 'aurelia-pal';
import DashboardEditorVM from './DashboardEditorVM';
import SortBy from "../../../../Lib/Fs.Core.Data/SortBy";
import DistrictGroupData from "../../Scripts/AppServiceContract/DistrictGroupData";
import DashboardAppService from "../../Scripts/AppServiceContract/DashboardAppService";
import DistrictData from "../../Scripts/AppServiceContract/DistrictData";
import StationData from "../../Scripts/AppServiceContract/StationData";
import AirQualityTypeData from "../../Scripts/AppServiceContract/AirQualityTypeData";
import AirQualityGroupData from "../../Scripts/AppServiceContract/AirQualityGroupData";
import ApexCharts from 'apexcharts';
import DashboardSearchCriteria from "../../Scripts/AppServiceContract/DashboardSearchCriteria";
import DashboardSearchParameter from "../../Scripts/AppServiceContract/DashboardSearchParameter";
import AirQualityGraphData from "../../Scripts/AppServiceContract/AirQualityGraphData";
import SearchOnlyVMBase2 from "../../../../Lib/Fs.SmartClient.Client/SearchOnlyVMBase2";
import { forEachCorner } from "ol/extent";
import StationParameter from "../../Scripts/AppServiceContract/StationParameter";
import { node } from "webpack";

@autoinject()
@useView(PLATFORM.moduleName("./DashboardSearchView.html"))
export default class DashboardSearchVM extends SearchOnlyVMBase2<DashboardEditorVM, DashboardSearchCriteria>{

  public i18n: I18N;
  public eventAggregator: EventAggregator;
  changeLocaleSubscribe: any;

  DistrictGroupList: DistrictGroupData[];
  DistrictGroupId: string;
  DistrictList: DistrictData[];
  DistrictId: string;
  StationList: StationData[];
  StationIds: string[];
  SelectedStationList: StationData[];
  AirQualityTypeList: AirQualityTypeData[];
  OutputType: number = 1;
  PeriodType: number = 1;
  DateStart: Date;
  DateEnd: Date;
  TimeStart: string;
  TimeEnd: string;
  SelectedAirQualityType: AirQualityTypeData[];
  startdateError: boolean = false;
  enddateError: boolean = false;
  starttimeError: boolean = false;
  endtimeError: boolean = false;
  zeroPad = (num, places) => String(num).padStart(places, '0')
  Showloading: boolean = false;
  Showgraph: boolean = false;
  Showtable: boolean = false;
  Placeholder: string;
  //public ThisMonth: number;
  public ThisYear: number;
  public monthListShow: any;
  public currentLocale: string;
  monthListTH = [
    { id: 0, name: 'มกราคม' },
    { id: 1, name: 'กุมภาพันธ์' },
    { id: 2, name: 'มีนาคม' },
    { id: 3, name: 'เมษายน' },
    { id: 4, name: 'พฤษภาคม' },
    { id: 5, name: 'มิถุนายน' },
    { id: 6, name: 'กรกฏาคม' },
    { id: 7, name: 'สิงหาคม' },
    { id: 8, name: 'กันยายน' },
    { id: 9, name: 'ตุลาคม' },
    { id: 10, name: 'พฤศจิกายน' },
    { id: 11, name: 'ธันวาคม' }
  ];

  monthListEN = [
    { id: 0, name: 'January' },
    { id: 1, name: 'Febuary' },
    { id: 2, name: 'March' },
    { id: 3, name: 'April' },
    { id: 4, name: 'May' },
    { id: 5, name: 'June' },
    { id: 6, name: 'July' },
    { id: 7, name: 'August' },
    { id: 8, name: 'September' },
    { id: 9, name: 'October' },
    { id: 10, name: 'November' },
    { id: 11, name: 'December' }
  ];

  constructor(i18n: I18N, eventAggregator: EventAggregator) {
    super(DashboardEditorVM);
    var self = this;
    this.i18n = i18n;
    this.eventAggregator = eventAggregator;

    this.changeLocaleSubscribe = this.eventAggregator.subscribe('ChangeLocale', (response) => {
      this.currentLocale = sessionStorage.getItem("CurrentSystemLocale");
      //self.Placeholder = self.i18n.tr('Aqs.Dashboard:DashboardPage.SelectStation');
      if (this.currentLocale == "th") {
        self.Placeholder = "เลือกสถานี"
        this.ThisYear = new Date().getFullYear() + 543;
        this.monthListShow = this.monthListTH
        this.CrateYearList();
      }
      else {
        self.Placeholder = "Select station";
        this.ThisYear = new Date().getFullYear();
        this.monthListShow = this.monthListEN
        this.CrateYearList();
      }
      this.HideGraphAndTable();
      this.Prepare();
    });
    this.Prepare();

    this.currentLocale = sessionStorage.getItem("CurrentSystemLocale");
    if (this.currentLocale == null) {
      this.currentLocale = "th"
    }

    if (this.currentLocale == "th") {
      this.ThisYear = new Date().getFullYear() + 543;
      this.monthListShow = this.monthListTH
      this.CrateYearList();
    }
    else {
      this.ThisYear = new Date().getFullYear();
      this.monthListShow = this.monthListEN
      this.CrateYearList();
    }

  }

  async Prepare() {
    this.LoadAirQualityType();
    this.LoadDistrictGroupDropdown();
    this.LoadDistrictDropdown();
    //this.LoadStationDropdown();
    this.SetDatetime();
  }
  TimeAll: string[] = [];
  SetDatetime() {
    var date = new Date;
    var d = date.getDate();
    var h = date.getHours();
    var dateYesterday = new Date(new Date(new Date().setDate(d - 1)).setHours(h + 1));
    this.DateStart = dateYesterday
    this.DateEnd = date
    for (var i = 0; i < 24; i++) {
      var x = i.toString();
      if (i < 10) x = "0" + x;
      this.TimeAll.push((x + ":00"));
    }
    this.TimeStart = this.zeroPad(date.getHours() + 1, 2) + ":00";
    this.TimeEnd = this.zeroPad(date.getHours(), 2) + ":00";
  }

  async LoadAirQualityType() {
    var self = this;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.AirQualityTypeList()
      .done((result) => {
        self.AirQualityTypeList = result;
        var html;
        html = "<div class='d-inline p-0'>";
        var x = result.length;
        for (let i = 1; i <= result.length; i++) {
          var id = "";
          if (i == 1) {
            id = "check-AirType-First";
          }
          else if (i == 2 || i == 3 || i == 4 || i == 7 || i == 8 || i == 9 || i == 12 || i == 13 || i == 14 || i == 17 || i == 18 || i == 19) {
            id = "check-AirType-2to4-7to9";
            if (i == result.length) id = "check-AirType-10";
          }
          else if (i == 5 || i == 15) {
            id = "check-AirType-5";
          }
          else if (i == 6 || i == 16) {
            id = "check-AirType-6";
            if (i == result.length) id = "check-AirType-RightOrOne";
          }
          else if (i == 10 || i == 20) {
            id = "check-AirType-10";
          }
          else if (i == 11) {
            id = "check-AirType-11";
            if (i == result.length) id = "check-AirType-One";
          }
          html = html + "<div id='" + id + "'><label class='d-flex mb-0'><input type='checkbox' id='" + result[i - 1].Name + "' style='display:none;'><span class='align-items-center flex-fill textSpan' style='font-size:smaller'>" + result[i - 1].DisplayName + "</span></label></div>";
        }
        html = html + "</div>";
        const div = document.getElementById('AirQualityType') as HTMLDivElement
        div.innerHTML = html;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  async LoadDistrictGroupDropdown() {
    var self = this;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.DistrictGroupDropdown()
      .done((result) => {
        self.DistrictGroupList = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  LoadDistrictDropdown() {
    var self = this;
    var param = new StationParameter();
    param.DistrictGroupId = this.DistrictGroupId;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.DistrictDropdown(param)
      .done((result) => {
        self.DistrictList = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  async LoadStationDropdown(params, success, failure) {
    var self = this;

    var param = new StationParameter();
    param.StationName = params.data.term ? params.data.term : ''
    param.DistrictGroupId = this.DistrictGroupId;
    param.DistrictId = this.DistrictId;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.StationDropdown(param)
      .done((result) => {
        success(result);
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  YearList: any;
  CrateYearList() {

    var self = this;
    var x = self.ThisYear - 2566;
    const y = { id: 1, name: self.ThisYear + 1 };
    self.YearList = []
    self.YearList.push(y);
    for (let i = 0; i <= x; i++) {
      self.YearList.push({ id: 1, name: self.ThisYear - i });
    }
  }

  ChangeDistrictGroup() {
    this.LoadDistrictDropdown();
    //this.LoadStationDropdown();
    this.StationIds = [];
    var x = this.i18n.tr('Aqs.Dashboard:DashboardPage.GraphSelect');
  }

  GetSelectedAirQualityType(): string[] {
    const ar = [];
    this.SelectedAirQualityType = [];
    for (var i in this.AirQualityTypeList) {
      const checkbox = document.getElementById(this.AirQualityTypeList[i].Name) as HTMLInputElement | null;
      if (checkbox?.checked) {
        ar.push(this.AirQualityTypeList[i].Name);
        this.SelectedAirQualityType.push(<AirQualityTypeData>{
          Id: this.AirQualityTypeList[i].Id,
          Name: this.AirQualityTypeList[i].Name,
          DisplayName: this.AirQualityTypeList[i].DisplayName,
          UnitDisplayName: this.AirQualityTypeList[i].UnitDisplayName
        });
      }
    }
    return ar;
  }

  HideGraphAndTable() {
    this.Showgraph = false;
    this.Showtable = false;
  }

  ShowLoading(flag) {
    this.Showloading = flag;
    if (flag) {
      const load = document.getElementById('load');
      load.scrollIntoView({ behavior: 'smooth' });
    }
  }

  ShowGraph() {
    this.ShowLoading(false);
    this.Showgraph = true;
    this.Showtable = false;
    this.GraphTabClick();
  }

  GraphTabClick() {
    var btn = document.getElementById('btn-' + this.SelectedAirQualityType[0].Name) as HTMLButtonElement;
    btn.click();
  }

  CreateChart(result: AirQualityGraphData[]) {
    var timeunit = this.i18n.tr('Aqs.Dashboard:DashboardPage.UnitTime');
    var standardtxt = this.i18n.tr('Aqs.Dashboard:DashboardPage.StandardTxt');
    var self = this;
    if (self.charts != null) {
      self.charts.forEach(t => {
        t.chart.destroy()
      });
    }
    self.charts = [];
    var Average = "Average";
    var Hourly = "Fact value";
    var Standard = "Standard value";
    if (self.currentLocale == "th") {
      Average = "ค่าเฉลี่ย";
      Hourly = "ค่าจริง";
      Standard = "ค่ามาตรฐาน";
    }
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    for (let i = 0; i < result.length; i++) {
      var noData = true;
      var StandardValue = 0;
      var StandardObj = self.AirQualityTypeList.find(t => t.Name == result[i].AirQualityTypeName);
      if (StandardObj != null) {
        StandardValue = StandardObj.StandardValue;
      }
      //for (let t = 0; t < this.AirQualityTypeList.length; t++) {
      //  if (this.AirQualityTypeList[t].Name == result[i].AirQualityTypeName) {
      //    if (this.AirQualityTypeList[t].StandardValue != null && this.AirQualityTypeList[t].StandardValue.toString() != "") {
      //      StandardValue = this.AirQualityTypeList[t].StandardValue;
      //    }
      //  }
      //}

      var name = this.SelectedAirQualityType.find(t => t.Name == result[i].AirQualityTypeName);
      var div = "#chart_" + name.Id;
      var div_element = document.getElementById("chart_" + name.Id) as HTMLDivElement;
      div_element.innerHTML = "";
      let Series = [];
      let Labels = [];
      let Marker = 0;
      var startdatetime = this.DateStart;
      var enddatetime = this.DateEnd;
      var caldate = enddatetime.getTime() - startdatetime.getTime();
      var conditiondate = caldate / (1000 * 3600 * 24);
      var options = {};
      let DataAvgColors = [];
      if (result[i].StationData.length == 1 && conditiondate <= 7 && !result[i].StationData[0]?.AirQualityData.every(t => t.AVGValue === null)) {

        let max = 0;
        let Data = [];
        let DataAvg = [];
        DataAvgColors = [];
        for (let k = 0; k < result[i].StationData[0].AirQualityData.length; k++) {

          Data.push(result[i].StationData[0].AirQualityData[k].Value == null ? null : result[i].StationData[0].AirQualityData[k].Value.toFixed());
          if (result[i].StationData[0].AirQualityData[k].Value != null) {
            noData = false;
          }
          DataAvg.push(result[i].StationData[0].AirQualityData[k].AVGValue == null ? null : result[i].StationData[0].AirQualityData[k].AVGValue?.toFixed());

          DataAvgColors.push(result[i].StationData[0].AirQualityData[k].AVGColor);
          if (max <= result[i].StationData[0].AirQualityData[k].Value) {
            max = result[i].StationData[0].AirQualityData[k].Value;
          }

          if (max <= result[i].StationData[0].AirQualityData[k].AVGValue) {
            max = result[i].StationData[0].AirQualityData[k].AVGValue;
          }

          var datetime = result[i].StationData[0].AirQualityData[k].DateTime;
          Labels.push(datetime);

        }

        //Creat Series
        Series.push({
          name: Average,
          data: DataAvg,
          type: "column",
        });

        Series.push({
          name: Hourly,
          data: Data,
          type: "line"
        });



        //Setting Chart
        options = {

          legend: {
            show: false,
          },

          plotOptions: {
            bar: {
              borderRadius: 5,
              borderRadiusApplication: "end",
              columnWidth: '50%',
            }
          },

          colors: [
            function ({ value, seriesIndex, dataPointIndex, w }) {
              return self.charts.find(t => t.Id == w.config.chart.id).DataAvgColors[dataPointIndex]
            },
            "#03754A"
          ],

          series: Series,
          chart: {
            id: name.Id,
            height: 350, type: 'line', zoom: { enabled: false },
            animations: { enabled: false },
            toolbar: { show: true, tools: { download: false } }
          },

          markers: { size: Marker },

          stroke: { width: 2, curve: 'straight' },

          labels: Labels,

          yaxis: {
            showAlways: true,
            max: max <= StandardValue ? StandardValue + 10 : max + 10,
            min: 0,
            title: {
              text: name.UnitDisplayName,
              rotate: -90,
              offsetX: 0,
              offsetY: 0,
              style: {
                color: '#ff0000',
                fontSize: '18px',
                fontWeight: 600,
                cssClass: 'apexcharts-yaxis-title',
              },
            },
          },

          xaxis: {
            type: "datetime",
            labels: { datetimeUTC: false, },
            tooltip: { enabled: false, },
          },

          annotations: StandardObj != null ? {
            yaxis: [{
              y: StandardValue,
              borderColor: '#FF0000',
              label: { borderColor: '#FF0000', style: { color: '#fff', background: '#FF0000' }, text: '' },

            }]
          } : {},

          tooltip: {
            y: {
              title: { formatter: (seriesName) => seriesName, },

              formatter: function (value, seriesIndex, w) {
                var id = w == undefined ? seriesIndex.w.config.chart.id : w.w.config.chart.id;
                var unit = self.charts.find(t => t.Id == id);
                return value + " " + unit.unitName
              },

              colors: [
                function ({ value, seriesIndex, dataPointIndex, w }) {
                  return self.charts.find(t => t.Id == w.config.chart.id).DataAvgColors[dataPointIndex]
                },
                "#03754A"
              ],

            },

            x: {
              show: true,
              formatter: function (value, seriesIndex, w) {
                var id = w == undefined ? seriesIndex.w.config.chart.id : w.w.config.chart.id;
                var unit = self.charts.find(t => t.Id == id);
                let dateTime = new Date(value);
                let showDate = new Intl.DateTimeFormat(self.currentLocale, { dateStyle: "full", timeStyle: "short" }).format(dateTime) + ' ' + timeunit + '<span style="color:red; font-weight:bold;">' + (unit.StandardValue == null ? '' : '&#10;&#13;' + standardtxt + ' : ' + unit.StandardValue) + '</span>';
                return showDate;
              },
            },
          }

        };
      }
      else {
        let max = 0;
        for (let j = 0; j < result[i].StationData.length; j++) {
          let Data = [];
          //var firstHours = new Date(result[i].StationData[j].AirQualityData[0].DateTime).getHours();
          for (let k = 0; k < result[i].StationData[j].AirQualityData.length; k++) {
            Data.push(result[i].StationData[j].AirQualityData[k].Value == null ? null : result[i].StationData[j].AirQualityData[k].Value.toFixed());
            if (result[i].StationData[0].AirQualityData[k].Value != null) {
              noData = false;
            }
            if (max <= result[i].StationData[j].AirQualityData[k].Value) {
              max = result[i].StationData[j].AirQualityData[k].Value;
            }
            var datetime = result[i].StationData[j].AirQualityData[k].DateTime;
            Labels.push(datetime);
          }

          //Creat Series
          Series.push({
            name: result[i].StationData[j].StationName,
            data: Data
          });
        }

        //Setting Chart
        options = {

          series: Series,
          chart: {
            id: name.Id,
            height: 350, type: 'line', zoom: { enabled: false },
            animations: { enabled: false },
            toolbar: { show: true, tools: { download: false } }
          },

          markers: { size: Marker },
          stroke: { width: 2, curve: 'straight' },
          labels: Labels,
          yaxis: {
            showAlways: true,
            max: max <= StandardValue ? StandardValue + 10 : max + 10,
            min: 0,
            title: {
              text: name.UnitDisplayName,
              rotate: -90,
              offsetX: 0,
              offsetY: 0,
              style: {
                color: '#ff0000',
                fontSize: '18px',
                fontWeight: 600,
                cssClass: 'apexcharts-yaxis-title',
              },
            },
          },

          xaxis: {
            type: "datetime",
            labels: { datetimeUTC: false, },
            tooltip: { enabled: false, },
          },

          annotations: {
            yaxis: [{
              y: StandardValue,
              borderColor: '#FF0000',
              label: { borderColor: '#FF0000', style: { color: '#fff', background: '#FF0000' }, text: '' }
            }]
          },

          tooltip: {

            y: {
              title: { formatter: (seriesName) => seriesName, },

              formatter: function (value, seriesIndex, w) {
                var id = w == undefined ? seriesIndex.w.config.chart.id : w.w.config.chart.id;
                var unit = self.charts.find(t => t.Id == id);
                return value + " " + unit.unitName
              },

              colors: [
                function ({ value, seriesIndex, dataPointIndex, w }) {
                  return self.charts.find(t => t.Id == w.config.chart.id).DataAvgColors[dataPointIndex]
                },
                "#03754A"
              ],

            },

            x: {
              show: true,
              formatter: function (value, seriesIndex, w) {
                var id = w == undefined ? seriesIndex.w.config.chart.id : w.w.config.chart.id;
                var unit = self.charts.find(t => t.Id == id);
                let dateTime = new Date(value);
                let showDate = new Intl.DateTimeFormat(self.currentLocale, { dateStyle: "full", timeStyle: "short" }).format(dateTime) + (unit.StandardValue == null ? '' : "&#10;&#13;ค่ามาตราฐาน: " + unit.StandardValue);
                debugger
                return showDate;
              },
            },
          }

        };
      }


      var divnodata = "nodata_" + name.Id;
      if (noData) {
        document.getElementById(divnodata).style.display = '';
      }
      else {
        document.getElementById(divnodata).style.display = 'none';
        var chart = new ApexCharts(document.querySelector(div), options);

        chart.render();

        self.charts.push({ chart: chart, StandardValue: StandardValue, unitName: name.UnitDisplayName, Id: name.Id, DataAvgColors: DataAvgColors });
      }



    }
    self.SelectAirQualityType = self.charts[0]?.Id;
  }

  charts: any;
  SelectAirQualityType: string;
  ShowTable() {
    this.ShowLoading(false);
    this.Showgraph = false;
    this.Showtable = true;
  }

  SearchCriteria: DashboardSearchCriteria;

  MonthStart: any;
  MonthEnd: any;
  YearStart: any;
  YearEnd: any;
  SelectStartYear: number;
  SelectEndYear: number;
  startMonthYear: number;
  endMonthYear: number;
  RawDate: Date = new Date();
  startDateFormat: Date;
  endDateFormat: Date;
  CreateCriteria(): DashboardSearchCriteria {
    var self = this;
    const criteria = new DashboardSearchCriteria();
    criteria.DistrictGroupId = this.DistrictGroupId;
    criteria.DistrictId = this.DistrictId;
    criteria.StationIds = this.StationIds;
    criteria.OutputType = this.OutputType;
    criteria.PeriodType = this.PeriodType;

    var startdatetime = new Date(this.zeroPad(this.DateStart.getFullYear(), 2) + "-" + this.zeroPad((this.DateStart.getMonth() + 1), 2) + "-" + this.zeroPad(this.DateStart.getDate(), 2) + " " + this.TimeStart);
    var enddatetime = new Date(this.zeroPad(this.DateEnd.getFullYear(), 2) + "-" + this.zeroPad((this.DateEnd.getMonth() + 1), 2) + "-" + this.zeroPad(this.DateEnd.getDate(), 2) + " " + this.TimeEnd);
    criteria.DateTimeStart = this.datejson(startdatetime);
    criteria.DateTimeEnd = this.datejson(enddatetime);
    criteria.AirQualityTypeList = this.GetSelectedAirQualityType();

    //Select Month Type
    if (this.PeriodType == 3 && this.currentLocale == "th") {
      self.SelectStartYear = this.YearStart.name - 543;
      self.SelectEndYear = this.YearEnd.name - 543;

      self.startMonthYear = this.RawDate.setFullYear(self.SelectStartYear, this.MonthStart.id, 1);
      self.endMonthYear = this.RawDate.setFullYear(self.SelectEndYear, this.MonthEnd.id + 1, 0);

      self.startDateFormat = new Date(self.startMonthYear);
      self.endDateFormat = new Date(self.endMonthYear);

      criteria.DateTimeStart = this.datejson(self.startDateFormat);
      criteria.DateTimeEnd = this.datejson(self.endDateFormat);
      //debugger
    }
    else if (this.PeriodType == 3 && this.currentLocale == "en") {
      self.SelectStartYear = this.YearStart.name;
      self.SelectEndYear = this.YearEnd.name;

      self.startMonthYear = this.RawDate.setFullYear(self.SelectStartYear, this.MonthStart.id, 1);
      self.endMonthYear = this.RawDate.setFullYear(self.SelectEndYear, this.MonthEnd.id + 1, 0);

      self.startDateFormat = new Date(self.startMonthYear);
      self.endDateFormat = new Date(self.endMonthYear);

      criteria.DateTimeStart = this.datejson(self.startDateFormat);
      criteria.DateTimeEnd = this.datejson(self.endDateFormat);
      //debugger
    }
    //End Select Month Type

    return criteria;
  }
  datejson(date: Date): any {
    date.setHours(date.getHours()+7);
    return '\/Date(' + date.getTime() + ')\/';
  }
  SearchItems(searchCallback: (result: AirQualityGroupData[]) => void, searchCriteria: DashboardSearchCriteria, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
    var self = this;
    const searchParameter = new DashboardSearchParameter();
    searchParameter.Criteria = searchCriteria;
    searchParameter.SortingCriteria = sortingCriteria;
    searchParameter.PagingCriteria = pagingCriteria;

    var service = this.container.get(DashboardAppService) as DashboardAppService;
    if (this.OutputType == 1) {
      service.FindGraph(searchParameter)
        .done((result) => {
          this.ShowGraph();
          this.CreateChart(result);
        })
        .fail((error) => {
          FsUtility.AlertErrorMessage(error);
        });
    }
    else {
      service.FindTable(searchParameter)
        .done((result) => {
          const tbody = document.getElementById('table').getElementsByTagName('tbody')[0];
          const table = document.getElementById('table') as HTMLTableElement;
          tbody.innerHTML = "";

          for (var i = 0; i < result.length; i++) {
            var newrow = tbody.insertRow();

            /*var newCell = newrow.insertCell();
            var newText = document.createTextNode(result[i].DistrictGroupName);
            newCell.appendChild(newText);*/

            var newCell = newrow.insertCell();
            var newText = document.createTextNode(result[i].DistrictName);
            newCell.style.textAlign = "center";
            newCell.appendChild(newText);

            var newCell = newrow.insertCell();
            var newText = document.createTextNode(result[i].StationName);
            newCell.style.textAlign = "center";
            newCell.appendChild(newText);

            var newCell = newrow.insertCell();
            var datetime = new Date(result[i].DateTime);

            const day = datetime.getDate();
            const monthIndex = datetime.getMonth();
            const year = datetime.getFullYear();
            const minutes = datetime.getMinutes();
            const hours = datetime.getHours();

            //Hourly
            if (this.PeriodType == 1) {
              var datetimeStr = day + "/" + (monthIndex + 1) + "/" + year + " " + this.zeroPad(hours, 2) + ":" + this.zeroPad(minutes, 2);
            }

            //Daily
            if (this.PeriodType == 2) {
              var datetimeStr = day + "/" + (monthIndex + 1) + "/" + year;
            }

            //Monthly
            if (this.PeriodType == 3) {
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              var datetimeStr = monthNames[monthIndex] + " " + year;;
            }

            var newText = document.createTextNode(datetimeStr);
            newCell.style.textAlign = "center";
            newCell.appendChild(newText);

            for (let j = 0; j < this.SelectedAirQualityType.length; j++) {
              var newCell = newrow.insertCell();
              var newText = document.createTextNode("");
              newCell.appendChild(newText);
            }

            for (let j = 0; j < result[i].AirQualityList.length; j++) {
              for (var c = 3, col; col = newrow.cells[c]; c++) {
                if (result[i].AirQualityList[j].TypeDisplayName == table.rows[0].cells[c].innerHTML) {
                  newrow.cells[c].innerText = result[i].AirQualityList[j].Value?.toString();
                  newrow.cells[c].style.textAlign = "center";
                }
              }
            }


          }

          if (result.length == 0) {
            var newrow = tbody.insertRow();
            var newCell = newrow.insertCell();
            var newText = document.createTextNode("ไม่พบข้อมูล");
            newCell.appendChild(newText);
          }

          searchCallback(result);
          this.ShowTable();
        }).fail((error) => {
          FsUtility.AlertErrorMessage(error);
        });
    }
  }

  CountItems(searchCallback: (result: number) => void) {
    var self = this;
    var req = self.CreateCriteria();
    var service = this.container.get(DashboardAppService) as DashboardAppService;
    service.Count(req)
      .done((result) => {
        searchCallback(result)
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  PrepareDefaultSortingCriteria(sortingCriteria: SortBy[]): void {
    var sortBy = new SortBy();
    sortBy.Direction = 0;
    sortBy.Name = "DateTime";
    sortingCriteria.push(sortBy);
  }

  Search() {
    if (this.OutputType == 1) {
      const searchParameter = new DashboardSearchParameter();
      searchParameter.Criteria = this.CreateCriteria();

      if (searchParameter.Criteria.DistrictId != null) {
        if (!searchParameter.Criteria.StationIds) {
          FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Station'), 1, 2, 3);
          this.ShowLoading(false);
          return;
        }
        else if (searchParameter.Criteria.StationIds.length == 0) {
          FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Station'), 1, 2, 3);
          this.ShowLoading(false);
          return;
        }
      }

      if (!searchParameter.Criteria.StationIds) {
        FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Station'), 1, 2, 3);
        this.ShowLoading(false);
        return;
      }

      var service = this.container.get(DashboardAppService) as DashboardAppService;
      service.FindGraph(searchParameter)
        .done((result) => {
          this.ShowGraph();
          this.CreateChart(result);
        })
        .fail((error) => {
          FsUtility.AlertErrorMessage(error);
        });

    }
    else {
      super.Search();
    }
  }

  Reset() {
    this.HideGraphAndTable();
  }

  SearchFunction() {
    this.HideGraphAndTable();
    //Validation
    this.startdateError = false;
    this.enddateError = false;
    this.starttimeError = false;
    this.endtimeError = false;
    /*if (this.DateStart == "") {
      this.startdateError = true;
      FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Datetime'), 1, 2, 3);
      return;
    }
    if (this.DateEnd == "") {
      this.enddateError = true;
      FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Datetime'), 1, 2, 3);
      return;
    }*/
    if (this.DateStart > this.DateEnd) {
      this.startdateError = true;
      this.enddateError = true;
      FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Datetime'), 1, 2, 3);
    }
    if (this.PeriodType == 1) {
      if (this.TimeStart == "") {
        this.starttimeError = true;
        FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Datetime'), 1, 2, 3);
        return;
      }
      if (this.TimeEnd == "") {
        this.endtimeError = true;
        FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.Datetime'), 1, 2, 3);
        return;
      }
    }
    this.GetSelectedAirQualityType();
    if (this.SelectedAirQualityType.length == 0) {
      FsUtility.AlertModal(this.i18n.tr('Aqs.Dashboard:Error.SelectAirQualityType'), 1, 2, 3);
      return;
    }
    this.HideGraphAndTable();
    this.ShowLoading(true);
    this.Search();
  }

  ChangePeriodType() {
    if (this.PeriodType == 1) {
      this.SetDatetime();
    }
    else if (this.PeriodType == 2) {
      this.DateStart = new Date(new Date().setMonth(new Date().getMonth() - 1));
    }
    else if (this.PeriodType == 3) {
      this.DateStart = new Date(new Date().setMonth(new Date().getMonth() - 12));
    }
  }

  SetAirQualityType(id: string) {
    this.SelectAirQualityType = id;
  }

  changeTab(val: string) {
    document.getElementById('btn-' + val).click();
    this.SelectAirQualityType = val;
  }

  SelectAllAirQualityType() {
    var check = true;
    for (var i in this.AirQualityTypeList) {
      const checkbox = document.getElementById(this.AirQualityTypeList[i].Name) as HTMLInputElement;
      if (checkbox != null) {
        if (!checkbox.checked) check = false;
        checkbox.checked = true;
      }
    }
    if (check) {
      for (var i in this.AirQualityTypeList) {
        const checkbox = document.getElementById(this.AirQualityTypeList[i].Name) as HTMLInputElement;
        if (checkbox != null) {
          checkbox.checked = false;
        }
      }
    }
  }
}
